import { WorkspaceSwitcher } from './WorkspaceSwitcher';
import { ConnectionStatus } from './ConnectionStatus';
import { UserMenu } from './UserMenu';
import { StatusSwitch } from './StatusSwitch';
import logo from '../../assets/mobile-logo.png';

/**
 * Top app header.
 *
 * Two visual zones, separated by a flex spacer so they don't collide:
 *
 *   [ Logo · brand · WorkspaceSwitcher ]      …      [ ConnectionStatus · UserMenu ]
 *
 * Earlier the workspace switcher and ConnectionStatus were both children of
 * a single `justify-between` flex band in the middle, which left them at
 * opposite ends of a wide empty band — visually orphaned. The grouping
 * here pairs each control with its conceptual neighbor: workspace selection
 * lives with brand identity on the left; live-status + identity menu live
 * together on the right.
 *
 * Brand text collapses below `sm` to reclaim room for the workspace pill.
 */
export function Header() {
  return (
    <header className="h-14 sm:h-16 bg-surface border-b border-line flex-shrink-0 shadow-card fixed top-0 left-0 right-0 z-50">
      <div className="h-full flex items-center px-3 sm:px-4 gap-2 sm:gap-3">
        {/* Brand + workspace — left zone */}
        <div className="flex items-center gap-2 sm:gap-3 min-w-0 flex-shrink">
          <img src={logo} alt="Chatbot" className="h-7 w-7 sm:h-8 sm:w-8 flex-shrink-0" />
          <span className="text-sm sm:text-base font-semibold text-ink hidden md:inline truncate">
            Chatbot Live
          </span>
          <WorkspaceSwitcher />
        </div>

        {/* Spacer */}
        <div className="flex-1" />

        {/* Status + user — right zone */}
        <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
          <StatusSwitch />
          <ConnectionStatus />
          <UserMenu />
        </div>
      </div>
    </header>
  );
}
